import FooterBottom from './FooterBottom';
import FooterSection from './FooterSection';
import FooterHeading from './FooterHeading';
import Footer from './Footer';
import FooterTop from './FooterTop';
export { FooterBottom, FooterSection, FooterHeading, FooterTop };
export default Footer;
//# sourceMappingURL=index.js.map